import { infoAPIClient } from '~utils/axios';
import objRemoveUnmatchedKeys from '~utils/objRemoveUnmatchedKeys';
import fieldTypes from '~utils/staticData/fieldTypes';

const INFO_API_ENCODED_AUTH = btoa(
  `${process.env.GATSBY_INFO_API_USERNAME}:${process.env.GATSBY_INFO_API_PASSWORD}`
);

const fieldTypesFormatted = {};
fieldTypes.forEach(
  ({ slug, description: longName, field_format: fieldFormat }) => {
    fieldTypesFormatted[slug] = { slug, longName, fieldFormat };
  }
);

async function fetchStateFields(stateCode) {
  const response = await infoAPIClient.get(
    `election/data/state/${stateCode}/`,
    {
      headers: {
        Authorization: `Basic ${INFO_API_ENCODED_AUTH}`,
      },
    }
  );

  const fields = {};
  response.data.state_information.forEach((field) => {
    fields[field.field_type] = {
      text: field.text,
      bool_value: field.bool_value,
      multiselect_value: field.multiselect_value,
      fieldType: fieldTypesFormatted[field.field_type],
      footnotes: field.footnotes,
    };
  });

  return { stateFields: fields, stateName: response.data.name };
}

export default function updatePersonFields(values) {
  function personChangedSelectedState(personStateUpdate, person) {
    // personStateUpdate.state !== person.state covers the case where the
    // user filled out the form once, we loaded their state fields, and then
    // they filled out the form again with a different state.
    return personStateUpdate.state !== person.state;
  }

  function stateWasPrefilledButStateFieldsAreEmpty(person) {
    // !person.stateFields covers the case where person.state was pre-populated
    // at load time from query parameters, so we have the user's state but
    // not their stateFields.
    return !person.stateFields;
  }

  return async function updatePersonFieldsInner(dispatch, getState) {
    // Filter down the provided values to just valid fields in the person data
    const { person } = getState();
    const personStateUpdate = objRemoveUnmatchedKeys(values, person);
    if (
      'state' in personStateUpdate &&
      (personChangedSelectedState(personStateUpdate, person) ||
        stateWasPrefilledButStateFieldsAreEmpty(person))
    ) {
      // we are changing the person's state -- fetch the new state data
      const { stateFields, stateName } = await fetchStateFields(
        personStateUpdate.state
      );

      personStateUpdate.stateFields = stateFields;
      personStateUpdate.stateName = stateName;
    }

    dispatch({ type: 'PERSON_UPDATE', person: personStateUpdate });
  };
}
